import React from "react";
import Tabla from "./Tabla";
import rol_icon from "../../../assets/vw/svg/rol.svg";
import ARCH from "../../../assets/vw/svg/archivo.svg";
import Loading from "../../../components/Loading";
import Menu from "../../../components/Menu";
import TablaArchivo from "./TablaInactivos";
import Modal from "../../../components/Modal";
import NoInfoScreen from "../../../components/Screens/NoInfoScreen";

class Rol extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      roles: [],
      rolesFiltradas: [],
      cargando: true,
      searchInput: "",
      option: "rol",
      dataOriginal: [],
      rolesInactivos: [],
      inactivosFiltradas: [],
      modal: {
        active: false,
        message: '',
        success: false
      },
    };
  }

  componentDidMount() {
    fetch(process.env.REACT_APP_URL_DTO_BACK + "roles?rol=todos", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + this.props.servicio.getToken(),
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        let responseBody = await res.json();
        if (!res.ok) {
          throw new Error(responseBody.mensaje);
        }
        const activas = responseBody.mensaje.filter((usuario) => {
          return usuario.activo === 1;
        });
        this.setState({
          roles: activas,
          dataOriginal: responseBody.mensaje,
          cargando: false,
        });
      })
      .catch((errorP) => {
        this.setState({
          cargando: false, modal: {
            active: true,
            message: errorP.message,
            success: false
          }
        });
      });
  }

  handleChange = (event) => {
    if (this.state.option === "archivo") {
      this.setState({ searchInput: event.target.value }, () => {
        this.globalSearchInactivas();
      });
    } else {
      this.setState({ searchInput: event.target.value }, () => {
        this.globalSearch();
      });
    }
  };

  globalSearch = () => {
    let { roles, searchInput } = this.state;
    if (searchInput && searchInput !== "") {
      let rolesFiltradas = roles.filter((value) => {
        return value.nombre.toLowerCase().includes(searchInput.toLowerCase());
      });
      this.setState({ rolesFiltradas });
    } else {
      let rolesFiltradas = [];
      this.setState({ rolesFiltradas });
    }
  };

  globalSearchInactivas = () => {
    let { rolesInactivos, searchInput } = this.state;
    if (searchInput && searchInput !== "") {
      let inactivosFiltradas = rolesInactivos.filter((value) => {
        return value.nombre.toLowerCase().includes(searchInput.toLowerCase());
      });
      this.setState({ inactivosFiltradas });
    } else {
      let inactivosFiltradas = [];
      this.setState({ inactivosFiltradas });
    }
  };

  changeOption = (option) => {
    this.setState({
      rolesFiltradas: [],
      rolesInactivos: [],
      inactivosFiltradas: [],
    });
    this.setState({ option });
    if (option === "archivo") {
      this.rolesInactivos(this.state.dataOriginal);
    }
  };

  rolesInactivos = (data) => {
    const inactivas = data.filter((rol) => {
      return rol.activo === 0;
    });
    this.setState({ rolesInactivos: inactivas });
  };

  render() {
    return (
      <>
        <Menu />
        <Modal
          modalInfo={this.state.modal}
          setMostrarModal={(data) => {
            this.setState({ modal: data });
          }}
        />
        {
          this.state.cargando && <Loading />
        }
        <div className={`navegacion`}>
          {this.state.dataOriginal.length > 0 ? (
            <>
              <div className=" posicionMenu">
                <ul className="d-flex flex-row px-0 my-0">
                  <li
                    className="opcion-ruta"
                    onClick={() => this.changeOption("rol")}
                  >
                    <div
                      className={`nav-link nav-link-title active ps-0 ${this.state.option === "rol" ? " active border_menu" : ""
                        }`}
                    >
                      <img src={rol_icon} alt="rol" className="icono-menu me-3" />
                      Rol
                    </div>
                  </li>
                  <li
                    className="opcion-ruta"
                    onClick={() => this.changeOption("archivo")}
                  >
                    <div
                      className={`nav-link active ps-0  ${this.state.option === "archivo"
                          ? " active border_menu"
                          : ""
                        }`}
                    >
                      <img src={ARCH} alt="archivo" className="icono-menu me-3" />
                      Archivo
                    </div>
                  </li>
                </ul>
              </div>
              <div className="row border_vw pt-4 ms-0 mx-0">
                <div className="col-12 p-0 contenedor-table">
                  {this.state.option === "archivo" ? (
                    <TablaArchivo
                      roles={
                        this.state.inactivosFiltradas &&
                          this.state.inactivosFiltradas.length
                          ? this.state.inactivosFiltradas
                          : this.state.rolesInactivos
                      }
                      servicio={this.props.servicio}
                      marca={this.props.marca}
                      marcaNombre={this.state.marca}
                      handleChange={this.handleChange}
                    ></TablaArchivo>
                  ) : (
                    <Tabla
                      roles={
                        this.state.rolesFiltradas &&
                          this.state.rolesFiltradas.length
                          ? this.state.rolesFiltradas
                          : this.state.roles
                      }
                      servicio={this.props.servicio}
                      marca={this.props.marca}
                      marcaNombre={this.state.marca}
                      handleChange={this.handleChange}
                    ></Tabla>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              {
                !this.state.cargando && <NoInfoScreen />
              }
            </>
          )
          }
        </div>
      </>
    );
  }
}

export default Rol;
